module.exports = {
	"baseAddress": "http://localhost:14145",
	"useRealApi": false,
	"fetchCredentialsHeader": "include"
};


//////////////////
// WEBPACK FOOTER
// ./src/js/serverApi/config.prod.json
// module id = 1074
// module chunks = 0